import React from "react";
import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/Footer/Footer";
import './registration-mfa-setup.css'
import { useNavigate } from "react-router-dom";
import { AcknowledgementModal } from "../../components/Modals/AcknowledgementModal/acknowledgement-modal";
import checkIcon from "../../assets/images/greenCheck.png";

export function MFAVerificationSuccessPage() {
  const router = useNavigate();

  function Dashboard() {
    router("/dashboard");
  }

  return (
    <>
      <Navbar />
      <section className="register-page-bg">
        <AcknowledgementModal
          id="mfa-verification-success-modal"
          icon={checkIcon}
          showDivider={true}
          header="Multi-Factor Authentication Enabled!"
          message={"No further action required, you can proceed to your dashboard!"}
          isActive={true}
          animate={false}
          onAcknowledge={Dashboard}
          buttonText={"Continue"}
        />
      </section>
      <Footer />
    </>
  );
}
